export const DEFAULT = "/";
export const ABOUT = "/about";
export const CONTROL_PANEL_UPGRADE = "/ControlPanelUpgrade/";
export const DCA_INSTALLER = "/DcaInstaller/:accessKey";
export const CONTROL_PANEL_INSTALLER = "/ControlPanelInstaller/:accessKey";
export const EMBEDDED_POWER_BI = "/embeddedPowerBi";
